// extracted by mini-css-extract-plugin
module.exports = {"page":"e462cbfa4b--page--nw7M5"};